import TitleComponent from "@/components/shared/TitleComponent";

export default function AdminGuidancePage() {
  return <TitleComponent title="Resources" />;
}
